<template>
  <main id="quote" class="page-container" v-if="$route.name === 'quotes'">
    <!-- Messaggi -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <div class="table-container-quote">
      <!-- LOADER OVERLAY -->
      <div
        v-if="isLoading"
        class="loader-overlay"
        aria-live="polite"
        aria-busy="true"
      >
        <div class="spinner" role="status"></div>
        <p>Carico i preventivi…</p>
      </div>

      <!-- Toolbar -->
      <div class="quotes-toolbar">
        <!-- [sc-48351 / task 7] «Preventivi» / «Bozze» (§2.7). Le bozze non
             stanno mescolate: un appunto da finire accanto a un preventivo
             mandato al cliente fa sembrare offerto un lavoro che non lo è. -->
        <div v-if="features.quoteDrafts" class="ordini-tabs">
          <button
            type="button"
            :class="['tab-btn', { active: !soloBozze }]"
            @click="cambiaScheda(false)"
          >
            Preventivi
          </button>
          <button
            type="button"
            :class="['tab-btn', { active: soloBozze }]"
            @click="cambiaScheda(true)"
          >
            Bozze
          </button>
        </div>
        <!-- [sc-48497 / task 48527] Un router-link non si spegne: non ha
             `disabled`, e restare cliccabile vorrebbe dire mandare il cliente
             su una schermata da cui la guardia lo rimbalza indietro. A prova
             finita al suo posto c'è il pulsante, spento. -->
        <template v-if="can('preventivi', 'C')">
          <router-link
            v-if="!isReadOnly"
            to="/home/preventivi/nuovo"
            class="primary-btn"
          >
            <i class="fa-solid fa-plus"></i> Nuovo preventivo
          </router-link>
          <button v-else class="primary-btn" type="button" disabled>
            <i class="fa-solid fa-plus"></i> Nuovo preventivo
          </button>
        </template>
        <button
          class="refresh-btn"
          :class="{ refreshed }"
          @click="handleRefresh"
          :disabled="refreshing"
          title="Aggiorna"
        >
          <i
            :class="[
              'fa-solid',
              refreshed ? 'fa-check' : 'fa-arrows-rotate',
              { 'fa-spin': refreshing },
            ]"
          ></i>
          <span>{{
            refreshing ? "Aggiorna…" : refreshed ? "Aggiornato!" : "Aggiorna"
          }}</span>
        </button>
      </div>

      <!-- Tabella -->
      <div class="tbl-wrap" :class="{ dimmed: isLoading }">
        <table class="tbl quote-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Da saldare</th>
              <th>Data</th>
              <th>Consegna / Ritiro</th>
              <th v-if="features.quoteDrafts">Stato</th>
              <th>Conferma</th>
              <th>Documenti</th>
              <th>Azioni</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="quote in allQuotes"
              :key="quote.id"
              class="quote-row"
              :class="{
                'quote-row--confirmed': quote.isConfirmed,
                'quote-row--incomplete': hasIncompleteStockItems(quote),
              }"
              :title="incompleteStockTitle(quote)"
            >
              <!-- <td>{{ quote.Client.clientName }}</td> -->
              <td
                class="client-cell"
                @mouseenter="onCellEnter(quote.id)"
                @mouseleave="onCellLeave(quote.id)"
              >
                <button
                  class="client-trigger"
                  @focus="onCellEnter(quote.id)"
                  @blur="onCellLeave(quote.id)"
                  @click.stop.prevent="toggleTooltip(quote.id)"
                  @touchstart.stop.prevent="onTriggerTouch(quote.id)"
                  @keydown="onTriggerKeydown($event, quote.id)"
                  :aria-expanded="isTooltipVisible(quote.id)"
                  :aria-describedby="'tt-' + quote.id"
                  type="button"
                >
                  {{ quote.Client?.clientName || "—" }}
                  <span class="sr-only">Apri contatti</span>
                  <span class="client-hint-mobile">Tocca per contatti</span>
                </button>

                <transition name="fade">
                  <div
                    v-if="isTooltipVisible(quote.id)"
                    :id="'tt-' + quote.id"
                    role="tooltip"
                    class="email-tooltip"
                    :class="{ 'no-pointer': lockClickId === quote.id }"
                    @click.stop
                    @touchstart.stop
                  >
                    <!-- CONTENUTO TOOLTIP -->
                    <div class="tooltip-row" v-if="quote?.Client?.email">
                      <span class="label">Email</span>
                      <a :href="'mailto:' + quote.Client.email">{{
                        quote.Client.email
                      }}</a>
                      <button
                        class="copy-btn"
                        @click="copyToClipboard(quote.Client.email, 'email')"
                        title="Copia email"
                      >
                        <i class="fa-regular fa-copy"></i>
                      </button>
                    </div>

                    <div class="tooltip-row" v-if="quote?.Client?.pec">
                      <span class="label">PEC</span>
                      <a :href="'mailto:' + quote.Client.pec">{{
                        quote.Client.pec
                      }}</a>
                      <button
                        class="copy-btn"
                        @click="copyToClipboard(quote.Client.pec, 'pec')"
                        title="Copia PEC"
                      >
                        <i class="fa-regular fa-copy"></i>
                      </button>
                    </div>

                    <div class="tooltip-row" v-if="quote?.Client?.phoneNumber">
                      <span class="label">Telefono</span>
                      {{ quote.Client.phoneNumber }}
                      <button
                        class="copy-btn"
                        @click="
                          copyToClipboard(quote.Client.phoneNumber, 'phone')
                        "
                        title="Copia numero di telefono"
                      >
                        <i class="fa-regular fa-copy"></i>
                      </button>
                    </div>

                    <div
                      class="tooltip-row muted"
                      v-if="
                        !quote?.Client?.email &&
                        !quote?.Client?.pec &&
                        !quote?.Client?.phoneNumber
                      "
                    >
                      Nessun contatto disponibile.
                    </div>
                  </div>
                </transition>
              </td>

              <td>
                <!-- [sc-48692] Pagato più del dovuto: un credito, non un
                     «Da saldare» negativo. Come nella lista ordini. -->
                <span
                  v-if="daRestituire(quote.realTotalPrice) > 0"
                  class="da-restituire"
                  title="Il cliente ha pagato più del totale"
                >
                  Da restituire
                  {{ formatPriceToPrint(daRestituire(quote.realTotalPrice)) }}
                </span>
                <template v-else>
                  {{ formatPriceToPrint(quote.realTotalPrice) }}
                </template>
              </td>
              <td class="date-cell">
                {{ formatToLocalDate(quote.date) }}
              </td>
              <td class="address-cell">
                <span
                  v-if="quote.deliveryType === 'ritiro'"
                  class="badge badge--ritiro"
                  >Ritiro</span
                >
                <!-- [sc-48351] Anche un indirizzo scritto a mano porta a
                     Maps, come in Clienti. -->
                <a
                  v-else-if="linkMaps(quote.location)"
                  :href="linkMaps(quote.location)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="custom-link"
                  >{{ formatAddress(quote.location.address) }}</a
                >
                <span v-else>{{
                  formatAddress(
                    quote.location?.address || "Indirizzo non disponibile"
                  )
                }}</span>
              </td>

              <!-- [sc-48351 / task 7] Lo stato d'offerta (§2.7): una tendina
                   come «Conferma» e «Pagamento», non una fila di pulsanti.
                   Le voci sono i passaggi possibili, presi dalla
                   configurazione gemella dell'API; a rifiutare un passaggio
                   sbagliato è comunque il server. -->
              <td v-if="features.quoteDrafts" class="state-container">
                <StatusSelect
                  :modelValue="quote.offerState || null"
                  :options="opzioniStato(quote)"
                  :disabled="
                    isReadOnly ||
                    showArchived ||
                    !can('preventivi', 'M') ||
                    statoInCorso === quote.id ||
                    passaggi(quote).length === 0
                  "
                  :placeholder="SENZA_STATO"
                  @update:modelValue="(val) => cambiaStato(quote, val)"
                />
              </td>

              <!-- Conferma -->
              <!-- [sc-48351 / task 7] Una bozza non si conferma: direbbe che
                   il cliente ha accettato un documento che non è finito di
                   scrivere. Il motivo sta nel titolo della cella, perché una
                   tendina spenta senza spiegazione sembra un guasto. -->
              <td class="state-container" :title="motivoNonConfermabile(quote)">
                <StatusSelect
                  :modelValue="quote.isConfirmed"
                  :options="CONFERMA_OPTIONS"
                  :disabled="
                    isReadOnly ||
                    Boolean(quote.isConfirmed) ||
                    eUnaBozza(quote) ||
                    !can('preventivi', 'A')
                  "
                  @update:modelValue="
                    (val) => {
                      quote.isConfirmed = val;
                      onQuoteStateChange(quote, 'isConfirmed', val);
                    }
                  "
                />
              </td>

              <!-- Documenti: visualizza PDF preventivo (apre la modale
                   documenti esistente; non rigenera il PDF, non modifica il
                   preventivo). "—" se il preventivo non ha documenti. -->
              <td class="documents-cell">
                <button
                  v-if="quote.documents && quote.documents.length"
                  class="icons-button"
                  @click="openDocumentsModal(quote, 'pdf')"
                  title="Visualizza PDF preventivo"
                  aria-label="Visualizza PDF preventivo"
                >
                  <i class="fa-solid fa-file-pdf"></i>
                </button>
                <span v-else class="no-doc" aria-hidden="true">—</span>
              </td>

              <!-- Azioni -->
              <td class="actions-cell">
                <template v-if="!quote.isConfirmed">
                  <router-link
                    v-if="!showArchived"
                    :to="`/home/preventivi/dettaglio/${quote.id}`"
                    class="icons-button"
                    title="Visualizza preventivo"
                    aria-label="Visualizza preventivo"
                  >
                    <i class="fa-solid fa-eye"></i>
                  </router-link>

                  <!-- [sc-48351 / task 48783] Sconto o maggiorazione sul
                       documento. La modale c'era già ma non la apriva più
                       nessuno: il pulsante era sparito quando la 48395 ha
                       spento la funzione. -->
                  <button
                    v-if="
                      features.priceModifiers &&
                      !showArchived &&
                      can('preventivi', 'M')
                    "
                    :disabled="isReadOnly"
                    class="icons-button"
                    @click="openDiscountModal(quote)"
                    title="Sconto o maggiorazione"
                    aria-label="Sconto o maggiorazione"
                  >
                    <i class="fa-solid fa-percent"></i>
                  </button>

                  <button
                    :disabled="isReadOnly"
                    v-if="!showArchived && can('preventivi', 'E')"
                    class="icons-button icons-button--danger"
                    @click="openArchiveModal(quote)"
                    title="Archivia preventivo"
                    aria-label="Archivia preventivo"
                  >
                    <i class="fa-solid fa-trash-can"></i>
                  </button>

                  <button
                    :disabled="isReadOnly"
                    v-else-if="
                      showArchived &&
                      canRestore(quote) &&
                      can('preventivi', 'E')
                    "
                    class="icons-button icons-button--danger"
                    @click="openRestoreModal(quote)"
                    title="Ripristina preventivo"
                    aria-label="Ripristina preventivo"
                  >
                    <i class="fa-solid fa-trash-arrow-up"></i>
                  </button>
                </template>

                <template v-else-if="can('ordini', 'V')">
                  <router-link
                    to="/home/ordini"
                    class="vai-ordine-btn"
                    title="Vai all'ordine"
                    aria-label="Vai all'ordine"
                  >
                    <i class="fa-solid fa-clipboard-list"></i>
                    <span>Vai all'ordine</span>
                  </router-link>
                </template>
              </td>
            </tr>
            <tr v-if="allQuotes.length === 0 && !isLoading">
              <!-- Con le bozze accese la tabella ha una colonna in più: un
                   colspan fisso lascerebbe lo stato vuoto stretto e storto. -->
              <td :colspan="features.quoteDrafts ? 8 : 7" class="no-result">
                <!-- [sc-48351] Lo stato vuoto dei Listini, anche qui. -->
                <EmptyState
                  v-if="searchTerm.trim()"
                  icon="fa-file-invoice"
                  title="Nessun preventivo corrisponde alla ricerca"
                  :text="`Nessun risultato per «${searchTerm.trim()}». Prova con un'altra parola, oppure azzera la ricerca per rivedere tutti i preventivi.`"
                >
                  <button class="empty-state__reset" @click="onResetSearch">
                    Azzera la ricerca
                  </button>
                </EmptyState>
                <EmptyState
                  v-else-if="soloBozze"
                  icon="fa-file-pen"
                  title="Nessuna bozza"
                  text="Le bozze sono i preventivi che stai ancora preparando: non entrano nei numeri e il cliente non le vede. Salvane una da «Nuovo preventivo»."
                />
                <EmptyState
                  v-else-if="showArchived"
                  icon="fa-box-archive"
                  title="Nessun preventivo archiviato"
                  text="I preventivi che archivi finiscono qui, e da qui si possono ripristinare."
                />
                <EmptyState
                  v-else
                  icon="fa-file-invoice"
                  title="Non hai ancora preventivi"
                  text="Crea il primo preventivo: quando il cliente lo conferma, diventa un ordine."
                >
                  <router-link
                    v-if="!isReadOnly && can('preventivi', 'C')"
                    to="/home/preventivi/nuovo"
                    class="primary-btn"
                  >
                    <i class="fa-solid fa-plus"></i> Crea il primo preventivo
                  </router-link>
                </EmptyState>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination / search / archived toggle -->
      <div class="pagination">
        <div class="pagination-left">
          <div class="search-container">
            <i
              v-if="!searchTerm"
              class="fa-solid fa-magnifying-glass search-icon"
            ></i>
            <input
              type="text"
              v-model="searchTerm"
              @keyup.enter="onSearch"
              placeholder="Cerca preventivi..."
              class="search-box"
            />

            <button
              v-if="searchTerm"
              @click="onResetSearch"
              class="clear-search-button"
              :disabled="isLoading"
            >
              <i class="fa-solid fa-times"></i>
            </button>
          </div>

          <label v-if="hasArchived" class="archived-toggle tooltip">
            <input
              type="checkbox"
              v-model="showArchived"
              @change="onToggleArchived($event)"
              class="visually-hidden"
              :aria-label="
                showArchived
                  ? 'Torna ai preventivi attivi'
                  : 'Mostra preventivi archiviati'
              "
            />
            <!-- [sc-48351] Il pulsante è il contenitore e l'icona sta
                 dentro, come in Documenti e Azioni: con la classe sull'icona
                 stessa il glifo restava in alto a sinistra. -->
            <span class="icons-button" aria-hidden="true">
              <i
                :class="[
                  'fa-solid',
                  showArchived ? 'fa-file-invoice' : 'fa-box-archive',
                ]"
              ></i>
            </span>
            <span class="tooltiptext">
              {{
                showArchived
                  ? "Torna ai preventivi attivi"
                  : "Mostra preventivi archiviati"
              }}
            </span>
          </label>
        </div>

        <div class="pagination-right">
          <div class="pagination-info">
            {{ testoConteggio(pagination) }}
          </div>

          <div class="pagination-controls">
            <button
              class="icons-button"
              @click="goToPage(1)"
              :disabled="isLoading || pagination.currentPage === 1"
              :title="
                isLoading || pagination.currentPage === 1
                  ? null
                  : 'Torna alla prima pagina'
              "
            >
              <i class="fa-solid fa-angles-left"></i>
            </button>
            <button
              class="icons-button"
              @click="goToPage(pagination.currentPage - 1)"
              :disabled="isLoading || pagination.currentPage === 1"
              :title="
                isLoading || pagination.currentPage === 1
                  ? null
                  : 'Torna alla pagina precedente'
              "
            >
              <i class="fa-solid fa-chevron-left"></i>
            </button>

            <button
              v-for="pageNum in visiblePages"
              :key="pageNum"
              @click="goToPage(pageNum)"
              :class="{ active: pagination.currentPage === pageNum }"
              class="pages-button"
            >
              {{ pageNum }}
            </button>

            <button
              class="icons-button"
              @click="goToPage(pagination.currentPage + 1)"
              :disabled="
                isLoading || pagination.currentPage === pagination.totalPages
              "
              :title="
                isLoading || pagination.currentPage === pagination.totalPages
                  ? null
                  : 'Vai alla pagina successiva'
              "
            >
              <i class="fa-solid fa-chevron-right"></i>
            </button>
            <button
              class="icons-button"
              @click="goToPage(pagination.totalPages)"
              :disabled="
                isLoading || pagination.currentPage === pagination.totalPages
              "
              :title="
                isLoading || pagination.currentPage === pagination.totalPages
                  ? null
                  : `Vai all'ultima pagina`
              "
            >
              <i class="fa-solid fa-angles-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- MODALE DOCUMENTI -->
      <VueFinalModal
        v-model="showDocumentsModal"
        :clickToClose="true"
        :escToClose="true"
        classes="documents-modal"
        content-class="documents-modal-content"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="closeDocumentsModal"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <h3 class="modal__title">
            {{
              docModalSection === "ddt" ? "Storico DDT" : "Documenti preventivo"
            }}
            #{{ currentQuoteId }}
          </h3>

          <!-- Documenti preventivo (PDF) -->
          <template v-if="docModalSection === 'pdf'">
            <transition-group name="card" tag="div" class="documents-grid">
              <div
                v-for="(doc, i) in filteredDocuments"
                :key="safeDocKey(doc, i)"
                class="document-card"
              >
                <a :href="doc.url" target="_blank" class="card-link">
                  <div class="card-icon-pdf">
                    <i class="fa-solid fa-file-pdf"></i>
                  </div>
                  <div class="card-body">
                    <div class="card-title">{{ formatDocName(doc.name) }}</div>
                    <div class="card-subtitle">
                      Data di creazione: {{ formatToLocalDate(doc.createdAt) }}
                    </div>
                    <div
                      v-if="
                        doc._quoteUpdatedAt &&
                        formatToLocalDateAndHours(doc._quoteUpdatedAt) !==
                          formatToLocalDateAndHours(doc.createdAt)
                      "
                      class="card-subtitle"
                    >
                      Aggiornato il:
                      {{ formatToLocalDateAndHours(doc._quoteUpdatedAt) }}
                    </div>
                  </div>
                </a>
                <!-- Un preventivo confermato è un ordine: l'API chiede
                     «ordini X». -->
                <button
                  v-if="
                    can(
                      selectedQuote?.isConfirmed ? 'ordini' : 'preventivi',
                      'X'
                    )
                  "
                  :disabled="isReadOnly"
                  class="icons-button card-email-btn"
                  :class="{ 'email-sent': emailSentMap[selectedQuote?.id] }"
                  :title="
                    emailSentMap[selectedQuote?.id]
                      ? 'Email già inviata in questa sessione'
                      : 'Invia email al cliente'
                  "
                  aria-label="Invia email al cliente"
                  @click.stop="onSendQuoteEmail(selectedQuote)"
                >
                  <i class="fa-solid fa-envelope"></i>
                </button>
              </div>

              <div v-if="filteredDocuments.length === 0" class="no-result">
                Nessun documento trovato
              </div>
            </transition-group>
          </template>

          <!-- Storico DDT -->
          <template v-if="features.ddt && docModalSection === 'ddt'">
            <div class="ddt-history documents-grid">
              <div v-if="selectedDdtDocuments.length === 0" class="no-result">
                Nessun DDT trovato per questo preventivo.
              </div>
              <template v-if="ddtDocumentsByCausale.consegna.length > 0">
                <div class="ddt-history__group-label">
                  Consegne
                  <span class="ddt-history__group-count"
                    >({{ ddtDocumentsByCausale.consegna.length }})</span
                  >
                </div>
                <div
                  v-for="(doc, idx) in ddtDocumentsByCausale.consegna"
                  :key="doc.id"
                  class="document-card"
                >
                  <a :href="doc.url" target="_blank" class="card-link">
                    <div class="card-icon-pdf">
                      <i class="fa-solid fa-file-pdf"></i>
                    </div>
                    <div class="card-body">
                      <div class="card-title">
                        DDT N° {{ doc._ddtId }}
                        <span class="ddt-history__seq"
                          >Consegna {{ idx + 1 }}</span
                        >
                      </div>
                      <div class="card-subtitle">
                        Data di creazione:
                        {{ formatToLocalDate(doc.createdAt) }}
                      </div>
                    </div>
                  </a>
                </div>
              </template>
              <template v-if="ddtDocumentsByCausale.reso.length > 0">
                <div class="ddt-history__group-label">Resi</div>
                <div
                  v-for="doc in ddtDocumentsByCausale.reso"
                  :key="doc.id"
                  class="document-card"
                >
                  <a :href="doc.url" target="_blank" class="card-link">
                    <div class="card-icon-pdf">
                      <i class="fa-solid fa-file-pdf"></i>
                    </div>
                    <div class="card-body">
                      <div class="card-title">DDT N° {{ doc._ddtId }}</div>
                      <div class="card-subtitle">
                        Data di creazione:
                        {{ formatToLocalDate(doc.createdAt) }}
                      </div>
                    </div>
                  </a>
                </div>
              </template>
              <template v-if="ddtDocumentsByCausale.ritiro.length > 0">
                <div class="ddt-history__group-label">Ritiri</div>
                <div
                  v-for="doc in ddtDocumentsByCausale.ritiro"
                  :key="doc.id"
                  class="document-card"
                >
                  <a :href="doc.url" target="_blank" class="card-link">
                    <div class="card-icon-pdf">
                      <i class="fa-solid fa-file-pdf"></i>
                    </div>
                    <div class="card-body">
                      <div class="card-title">DDT N° {{ doc._ddtId }}</div>
                      <div class="card-subtitle">
                        Data di creazione:
                        {{ formatToLocalDate(doc.createdAt) }}
                      </div>
                    </div>
                  </a>
                </div>
              </template>
            </div>
          </template>
        </template>
      </VueFinalModal>

      <!-- MODALE ARCHIVIAZIONE -->
      <VueFinalModal
        v-model="showArchiveModal"
        :clickToClose="!archiving"
        :escToClose="!archiving"
        classes="documents-modal"
        content-class="confirm-modal-content modal--archive"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="closeArchiveModal"
            :disabled="archiving"
            title="Chiudi"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Archivia preventivo</h3>
          <p class="modal__subtitle">
            Archiviare il preventivo
            <strong>#{{ currentQuoteId }}</strong>
            di
            <strong>{{ selectedQuote?.Client?.clientName }}</strong
            >?
          </p>

          <div class="modal-actions">
            <button
              class="secondary-btn"
              @click="closeArchiveModal"
              :disabled="archiving"
            >
              Annulla
            </button>
            <button
              class="primary-btn confirm-btn"
              @click="confirmArchive"
              :disabled="isReadOnly || archiving"
            >
              <span v-if="archiving">Archivia…</span>
              <span v-else>Archivia</span>
            </button>
          </div>
        </template>
      </VueFinalModal>

      <!-- MODALE RIPRISTINO -->
      <VueFinalModal
        v-model="showRestoreModal"
        :clickToClose="!restoring"
        :escToClose="!restoring"
        classes="documents-modal"
        content-class="confirm-modal-content modal--restore"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="closeRestoreModal"
            :disabled="restoring"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Ripristina preventivo</h3>
          <p class="modal__subtitle">
            Ripristinare il preventivo
            <strong>#{{ currentQuoteId }}</strong>
            di
            <strong>{{ selectedQuote?.Client?.clientName }}</strong> dagli
            archivi?
          </p>

          <div class="modal-actions">
            <button
              class="secondary-btn"
              @click="closeRestoreModal"
              :disabled="restoring"
            >
              Annulla
            </button>
            <button
              class="primary-btn confirm-btn"
              @click="confirmRestore"
              :disabled="isReadOnly || restoring"
            >
              <span v-if="restoring">Ripristino…</span>
              <span v-else>Ripristina</span>
            </button>
          </div>
        </template>
      </VueFinalModal>

      <!-- MODALE CONFERMA CAMBIO STATO -->
      <VueFinalModal
        v-model="showConfirmModal"
        :clickToClose="!confirmBusy"
        :escToClose="!confirmBusy"
        classes="documents-modal"
        content-class="confirm-modal-content modal--state"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="handleConfirmCancel"
            :disabled="confirmBusy"
            title="Chiudi"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">{{ confirmTitle }}</h3>
          <p class="modal__subtitle" v-html="confirmMessage"></p>

          <div class="modal-actions">
            <button
              class="secondary-btn"
              @click="handleConfirmCancel"
              :disabled="confirmBusy"
            >
              Annulla
            </button>
            <button
              class="primary-btn confirm-btn"
              @click="handleConfirmOK"
              :disabled="confirmBusy"
            >
              <span v-if="confirmBusy">{{ confirmBusyLabel }}</span>
              <span v-else>{{ confirmLabel }}</span>
            </button>
          </div>
        </template>
      </VueFinalModal>

      <!-- MODIFICATORE PREZZI - riacceso per PLUS dalla task 48783, senza il
           ramo «Acconto» che scriveva la cache dei pagamenti -->
      <VueFinalModal
        v-if="features.priceModifiers"
        v-model="showDiscountModal"
        :clickToClose="true"
        :escToClose="true"
        classes="documents-modal"
        content-class="documents-modal-content"
      >
        <template #default>
          <button class="modal__close icons-button" @click="closeDiscountModal">
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Preventivo #{{ currentQuoteId }}</h3>

          <!-- [sc-48351 / task 48783] Il pannello sta in un componente:
               serve identico anche in Ordini, e due copie dello stesso conto
               sarebbero due copie da tenere allineate. Le card dei documenti
               qui non ci sono più: il PDF si guarda dalla sua modale, e in
               questa non c'entrava niente. -->
          <div v-if="quoteDelModificatore" class="quote-modifier">
            <PriceModifierModal
              :quote="quoteDelModificatore"
              :read-only="isReadOnly"
              @applied="modificatoreApplicato(quoteDelModificatore, $event)"
            />
          </div>
        </template>
      </VueFinalModal>
    </div>

    <DdtModal
      v-if="features.ddt"
      :show="showDdtModal"
      :items="ddtModalItems"
      :quote-id="ddtModalQuoteId"
      :client-id="ddtModalClientId"
      :client-name="ddtModalClientName"
      @update:show="showDdtModal = $event"
    />
  </main>
  <router-view></router-view>
</template>

<script>
import EmptyState from "@/components/EmptyState.vue";
import { testoConteggio } from "@/utilities/conteggioPagine";
import { linkMaps } from "@/utilities/mapsLink";
import axiosInstance from "@/axiosInstance";
import { formatDocName as docNameLabel } from "@/utilities/documentName";
import PriceModifierModal from "@/components/PriceModifierModal.vue";
import { generateQuotePdf } from "@/utilities/generateQuotePdf";
import { daRestituire } from "@/utilities/pagamenti";
import {
  hasIncompleteStockData,
  missingStockFields,
  itemStockLabel,
} from "@/utilities/itemStockData";
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import {
  formatPriceToPrint,
  formatToLocalDate,
  formatToLocalDateAndHours,
} from "../utilities/formatting";
import DdtModal from "@/components/DdtModal.vue";
import StatusSelect from "@/components/StatusSelect.vue";
import {
  opzioniPer,
  passaggiPossibili,
  SENZA_STATO,
  STATI_OFFERTA,
} from "@/config/bozze";

const CONFERMA_OPTIONS = [
  { value: false, label: "In attesa", color: "#ffa726" },
  { value: true, label: "Confermato", color: "#4caf50" },
];

const PAGAMENTO_OPTIONS = [
  { value: "In attesa", label: "In attesa", color: "#ffa726" },
  { value: "Pagato", label: "Pagato", color: "#4caf50" },
];

const SPEDIZIONE_COLOR = {
  "In magazzino": "#9ca3af",
  "In consegna": "#ffa726",
  Consegnato: "#4caf50",
};

export default {
  components: {
    DdtModal,
    StatusSelect,
    EmptyState,
    PriceModifierModal,
  },

  computed: {
    // [sc-48351 / task 48786] I bottoni seguono il ruolo: nascosti, non
    // spenti — un bottone grigio senza spiegazione sembra un guasto.
    can() {
      return this.$store.getters["auth/can"];
    },
    ...mapGetters({
      allQuotes: "quotes/list",
      pagination: "quotes/pagination",
    }),

    /**
     * Funzioni accese per l'azienda collegata.
     * [sc-48351] Dal piano dell'azienda, via store, non più da `features.js`.
     */
    features() {
      return this.$store.getters["company/features"];
    },

    /** Il preventivo aperto nella modale del modificatore, o `null`. */
    quoteDelModificatore() {
      if (this.currentQuoteId == null) return null;
      return this.allQuotes.find((q) => q.id === this.currentQuoteId) || null;
    },

    visiblePages() {
      const range = 2;
      const start = Math.max(1, this.pagination.currentPage - range);
      const end = Math.min(
        this.pagination.totalPages,
        this.pagination.currentPage + range
      );
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    filteredDocuments() {
      const list = Array.isArray(this.selectedDocuments)
        ? this.selectedDocuments
        : [];
      const term = (this.docSearchTerm || "").toLowerCase().trim();
      const seen = new Set();
      return list.filter(Boolean).filter((doc) => {
        const k = doc.id ?? doc.name ?? doc.url ?? Math.random();
        if (seen.has(k)) return false;
        seen.add(k);
        return term ? (doc.name || "").toLowerCase().includes(term) : true;
      });
    },
    ddtDocumentsByCausale() {
      const groups = { consegna: [], reso: [], ritiro: [] };
      for (const doc of this.selectedDdtDocuments) {
        const key = doc._causale in groups ? doc._causale : "consegna";
        groups[key].push(doc);
      }
      const byDate = (a, b) => new Date(a.createdAt) - new Date(b.createdAt);
      return {
        consegna: [...groups.consegna].sort(byDate),
        reso: [...groups.reso].sort(byDate),
        ritiro: [...groups.ritiro].sort(byDate),
      };
    },
  },

  data() {
    return {
      tooltipOpenId: null,
      hoveredId: null,
      hideTimer: null,
      lockClickId: null, // anti-ghost click

      isLoading: false,
      CONFERMA_OPTIONS,
      PAGAMENTO_OPTIONS,

      refreshing: false,
      refreshed: false,
      errorMessage: "",
      successMessage: "",
      currentPage: 1,
      searchTerm: "",
      currentQuoteId: null,
      showDocumentsModal: false,
      docModalSection: "pdf",
      selectedDocuments: [],
      selectedDdtDocuments: [],
      showArchived: false,
      hasArchived: false,
      filterConfirmed: undefined,
      /** [sc-48351 / task 7] La scheda «Bozze» è aperta. */
      soloBozze: false,
      /** Su quale preventivo c'è un passaggio di stato in corso. */
      statoInCorso: null,
      SENZA_STATO,
      docSearchTerm: "", // per ricerca documenti nella modale

      /* Modali archiviazione / ripristino */
      showArchiveModal: false,
      archiving: false,
      showRestoreModal: false,
      restoring: false,
      selectedQuote: null,

      showConfirmModal: false,
      showDiscountModal: false,
      confirmTitle: "",
      confirmMessage: "",
      confirmLabel: "Conferma",
      confirmBusyLabel: "Aggiorno…",
      confirmBusy: false,
      removeModifierBusy: false,
      emailSentMap: {},
      pendingChange: null, // { id, field, newValue }

      showDdtModal: false,
      ddtModalItems: [],
      ddtModalQuoteId: null,
      ddtModalClientId: null,
      ddtModalClientName: null,
    };
  },

  methods: {
    testoConteggio,
    linkMaps,
    daRestituire,
    spedizioneOptions(quote) {
      return this.availableStateOptions(quote).map((opt) => ({
        ...opt,
        color: SPEDIZIONE_COLOR[opt.value] ?? "#9ca3af",
      }));
    },

    formatAddress(address) {
      if (!address) return "Indirizzo non disponibile";
      const withCap = address.replace(/,?\s+(\d{5}\s)/, "\n$1");
      if (withCap !== address) return withCap;
      return address.replace(/,\s*/, ",\n");
    },

    async handleRefresh() {
      this.refreshing = true;
      this.refreshed = false;
      try {
        await this.getQuotes(this.pagination.currentPage);
      } finally {
        this.refreshing = false;
        this.refreshed = true;
        setTimeout(() => {
          this.refreshed = false;
        }, 1500);
      }
    },

    availableStateOptions(quote) {
      const s = quote.state;
      if (s === "In magazzino") {
        return [
          { value: "In magazzino", label: "In magazzino", disabled: true },
          { value: "In consegna", label: "In consegna", disabled: false },
        ];
      }
      if (s === "In consegna") {
        return [
          { value: "In consegna", label: "In consegna", disabled: true },
          { value: "Consegnato", label: "Consegnato", disabled: false },
        ];
      }
      return [
        { value: s || "Consegnato", label: s || "Consegnato", disabled: true },
      ];
    },

    isStateSelectDisabled(quote) {
      if (quote.state === "Consegnato") return true;
      if (quote.state === "In magazzino") {
        return !quote.isConfirmed || quote.payment_state !== "Pagato";
      }
      return !quote.isConfirmed;
    },

    /**
     * Il componente ha applicato o tolto un modificatore: qui si aggiorna la
     * riga in lista e si rigenera il PDF, che è l'unico posto dove il cliente
     * legge il nuovo totale.
     */
    async modificatoreApplicato(quote, esito) {
      const q = this.allQuotes.find((x) => x.id === quote.id);
      if (q) {
        const percentuale =
          esito.modo === "percentuale" ? Number(esito.valore) : 0;
        if (esito.tipo === "sconto") {
          q.discount = esito.tolto ? 0 : esito.importo;
          q.discount_percent = esito.tolto ? 0 : percentuale;
        } else {
          q.surcharge = esito.tolto ? 0 : esito.importo;
          q.surcharge_percent = esito.tolto ? 0 : percentuale;
          q.realTotalPrice = esito.tolto
            ? Number(q.totalPrice) || 0
            : esito.totale;
        }
      }
      this.$toast.success(esito.messaggio || "Documento aggiornato.");

      const qLocal = this.allQuotes.find((x) => x.id === quote.id);
      const needsFetch = !qLocal?.quote_items?.some((qi) => qi?.item);
      const dataForPdf = needsFetch
        ? await this.getQuotebyId(quote.id)
        : qLocal;
      await generateQuotePdf({
        quote: dataForPdf,
        toast: this.$toast,
        uploadQuoteDocument: (payload) =>
          this.$store.dispatch("uploadQuoteDocument", payload),
        onComplete: async () => {
          await this.getQuotes(this.pagination.currentPage);
        },
      });
      this.closeDiscountModal();
    },

    openDdtModal(quote) {
      if (!this.features.ddt) return;
      const AREA_CATS = [
        "piastrelle",
        "rivestimenti parete",
        "parquet",
        "laminati",
        "decking esterno",
      ];
      const LINEAR_CATS = ["profili", "sistemi di scarico"];
      const rows = [];
      const seen = new Set();

      (quote.items || []).forEach((it) => {
        seen.add(it.id);
        const isArea = AREA_CATS.includes((it.category || "").toLowerCase());
        const isLinear = LINEAR_CATS.includes(
          (it.category || "").toLowerCase()
        );
        const qty = it?.QuoteItem?.quantity ?? 0;
        const uom = it.salesUnit || (isArea ? "SC" : isLinear ? "CONF" : "PZ");
        rows.push({
          description: it.itemName || it.supplierCode || it.itemCode || "—",
          quantity: qty,
          uom,
        });
      });

      (quote.quote_items || []).forEach((qi) => {
        if (qi?.item?.id && seen.has(qi.item.id)) return;
        const it = qi.item || {};
        const isArea = AREA_CATS.includes((it.category || "").toLowerCase());
        const isLinear = LINEAR_CATS.includes(
          (it.category || "").toLowerCase()
        );
        const uom = it.salesUnit || (isArea ? "SC" : isLinear ? "CONF" : "PZ");
        rows.push({
          description: it.itemName || it.supplierCode || it.itemCode || "—",
          quantity: qi.quantity ?? 0,
          uom,
        });
      });

      this.ddtModalItems = rows;
      this.ddtModalQuoteId = quote.id;
      this.ddtModalClientId = quote.clientId || null;
      this.ddtModalClientName = quote?.Client?.clientName || null;
      this.showDdtModal = true;
    },

    ...mapActions([
      "fetchQuotes",
      "archiveQuote",
      "restoreQuote",
      "hasArchivedQuotes",
      "uploadQuoteDocument",
      "sendQuoteDocumentEmail",
      "setOfferState",
    ]),

    /* ----- [sc-48351 / task 7] Bozze (§2.7) ----- */

    /** Passa da «Preventivi» a «Bozze» e ricarica dalla prima pagina. */
    cambiaScheda(bozze) {
      if (this.soloBozze === bozze) return;
      this.soloBozze = bozze;
      this.currentPage = 1;
      this.getQuotes(1);
    },

    /** Dove può andare questo preventivo. Vuoto: non c'è niente da offrire. */
    passaggi(quote) {
      return passaggiPossibili(quote.offerState);
    },

    /** Le voci della tendina: dove si è, spento, e dove si può andare. */
    opzioniStato(quote) {
      return opzioniPer(quote.offerState);
    },

    eUnaBozza(quote) {
      return quote.offerState === STATI_OFFERTA.BOZZA;
    },

    /** Perché «Conferma» è spenta, o stringa vuota se non lo è. */
    motivoNonConfermabile(quote) {
      if (quote.isConfirmed) return "";
      if (this.eUnaBozza(quote)) {
        return "È una bozza: segnala pronta o inviata prima di confermarla.";
      }
      // [sc-48351 / task 48786] Confermare è approvare il preventivo.
      if (!this.can("preventivi", "A")) {
        return "Il tuo ruolo non permette di confermare i preventivi.";
      }
      return "";
    },

    /**
     * Il passaggio di stato.
     *
     * Ricarica l'elenco invece di ritoccare la riga: lo stato cambia anche
     * l'insieme a cui il preventivo appartiene, e una bozza diventata
     * «pronta» resterebbe nella scheda delle bozze a dire il falso.
     */
    async cambiaStato(quote, offerState) {
      this.statoInCorso = quote.id;
      try {
        await this.setOfferState({ quoteId: quote.id, offerState });
        this.$toast.success(`Preventivo #${quote.id}: ${offerState}.`);
        await this.getQuotes(this.pagination.currentPage);
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          "Non riesco a cambiare lo stato del preventivo.";
        this.errorMessage = msg;
        this.$toast.error(msg);
      } finally {
        this.statoInCorso = null;
      }
    },

    async onSendQuoteEmail(quote) {
      const doc = (quote.documents || []).at(-1);
      if (!doc) return;
      try {
        await this.sendQuoteDocumentEmail({
          quoteId: quote.id,
          objectName: doc.name,
        });
        this.emailSentMap = { ...this.emailSentMap, [quote.id]: true };
        this.$toast.success("Email inviata al cliente con successo.");
      } catch (err) {
        const msg =
          err.response?.data?.error || "Errore durante l'invio dell'email.";
        this.$toast.error(msg);
      }
    },

    isTooltipVisible(id) {
      return this.tooltipOpenId === id || this.hoveredId === id;
    },
    applyTooltipPlacement(id) {
      const tip = document.getElementById("tt-" + id);
      if (tip) tip.dataset.placement = "over";
    },
    onCellEnter(id) {
      clearTimeout(this.hideTimer);
      this.hoveredId = id;
      this.$nextTick(() => this.applyTooltipPlacement(id));
    },
    onCellLeave(id) {
      clearTimeout(this.hideTimer);
      // piccolo delay per evitare micro-sfarfallii
      this.hideTimer = setTimeout(() => {
        // se non è aperto "sticky" con click, chiudi l'hover
        if (this.tooltipOpenId !== id) this.hoveredId = null;
      }, 120);
    },
    toggleTooltip(id) {
      this.tooltipOpenId = this.tooltipOpenId === id ? null : id;
      if (this.tooltipOpenId === id) {
        this.hoveredId = id;
        this.lockClickId = id; // blocca click subito dopo l’apertura
        setTimeout(() => {
          if (this.lockClickId === id) this.lockClickId = null;
        }, 250); // ~250ms bastano per il ghost click
        this.$nextTick(() => this.applyTooltipPlacement(id));
      }
    },

    onTriggerTouch(id) {
      // equivalente touch del click, con lock sicuro
      this.tooltipOpenId = this.tooltipOpenId === id ? null : id;
      if (this.tooltipOpenId === id) {
        this.hoveredId = id;
        this.lockClickId = id;
        setTimeout(() => {
          if (this.lockClickId === id) this.lockClickId = null;
        }, 250);
        this.$nextTick(() => this.applyTooltipPlacement(id));
      }
    },
    onTriggerKeydown(e, id) {
      if (e.key === "Escape") {
        this.tooltipOpenId = null;
        this.hoveredId = null;
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.toggleTooltip(id);
      }
    },
    // se vuoi mantenere queste API:
    showTooltip(id) {
      this.onCellEnter(id);
    },
    hideTooltip() {
      // opzionale: se chiamata da blur del bottone
      const id = this.tooltipOpenId ?? this.hoveredId;
      this.onCellLeave(id);
    },
    handleDocumentClick(e) {
      // chiudi se clicco fuori da qualsiasi .client-cell
      if (!e.target.closest(".client-cell")) {
        this.tooltipOpenId = null;
      }
    },
    async copyToClipboard(text, kind = null) {
      const value = String(text ?? "").trim();

      // Se il tipo non è passato, prova a inferirlo
      if (!kind) {
        if (/^\+?[\d()\s.-]{5,}$/.test(value)) kind = "phone";
        else if (/@/.test(value)) kind = "email"; // PEC se vuoi, vedi sotto
        else kind = "text";
      }

      try {
        await navigator.clipboard.writeText(value);

        const msgMap = {
          phone: "Numero di telefono copiato",
          email: "Email copiata",
          pec: "PEC copiata",
          text: "Testo copiato",
        };

        this.$toast?.success?.(`${msgMap[kind] || msgMap.text} negli appunti`);
      } catch {
        this.$toast?.error?.("Impossibile copiare negli appunti");
      }
    },

    safeDocKey(doc, i) {
      if (doc && doc.id != null) return "doc-" + String(doc.id);
      if (doc && doc.url) return "url-" + doc.url;
      if (doc && doc.name) return "name-" + doc.name;
      return "idx-" + String(i);
    },

    formatToLocalDate,
    formatToLocalDateAndHours,
    formatPriceToPrint,

    formatDocName(name) {
      // [sc-48497 / task 48531] La pulizia sta in un posto solo: quattro
      // pagine la facevano ognuna per conto suo, e il prefisso dell'azienda
      // andava tolto in tutte e quattro.
      return docNameLabel(name);
    },

    async openDocumentsModal(quote, section = "pdf") {
      this.currentQuoteId = quote?.id ?? null;
      this.selectedQuote = quote;
      this.docModalSection = section;
      this.selectedDocuments = [];
      this.docSearchTerm = "";
      this.showDocumentsModal = true;
      const quoteDocs = (quote.documents || []).filter(Boolean).map((d) => ({
        ...d,
        _type: "quote",
        _quoteUpdatedAt: quote.updatedAt ?? null,
      }));
      let ddtDocs = [];
      // [sc-48351 / task 48786] Senza «ddt V» l'API risponde 403: non si chiede.
      if (this.features.ddt && quote.id && this.can("ddt", "V")) {
        try {
          const { data } = await axiosInstance.get("/ddt", {
            params: { quoteId: quote.id },
          });
          ddtDocs = (data || [])
            .filter((d) => d.documentUrl)
            .map((d) => ({
              id: `ddt-${d.id}`,
              name: `DDT_N_${d.id}.pdf`,
              url: d.documentUrl,
              createdAt: d.date ?? d.createdAt,
              _type: "ddt",
              _causale: d.causale,
              _ddtId: d.id,
            }));
        } catch {
          /* ignora errori fetch DDT */
        }
      }
      this.selectedDocuments = quoteDocs;
      this.selectedDdtDocuments = ddtDocs;
    },
    closeDocumentsModal() {
      this.showDocumentsModal = false;
      this.docModalSection = "pdf";
      this.selectedDocuments = [];
      this.selectedDdtDocuments = [];
      this.currentQuoteId = null;
      this.selectedQuote = null;
      this.docSearchTerm = "";
    },

    /* ----- ARCHIVIAZIONE / RIPRISTINO con modale ----- */
    openArchiveModal(quote) {
      this.currentQuoteId = quote?.id ?? null;
      this.selectedQuote = quote;
      this.showArchiveModal = true;
    },
    closeArchiveModal() {
      if (this.archiving) return;
      this.showArchiveModal = false;
      this.selectedQuote = null;
      this.currentQuoteId = null;
    },
    async confirmArchive() {
      if (!this.selectedQuote) return;
      try {
        this.archiving = true;
        let response;
        if (this.$store._actions?.archiveQuote) {
          response = await this.archiveQuote(this.selectedQuote.id);
        } else {
          response = await this.$axios.patch(
            `quote/archive/${this.selectedQuote.id}`,
            { archived: true }
          );
        }
        this.successMessage =
          response.data?.message || "Preventivo archiviato con successo.";
        this.$toast.success(this.successMessage);

        this.showArchiveModal = false;
        this.currentQuoteId = null;

        await this.refreshArchivedFlag();
        // await this.fetchQuotes({
        //   page: this.pagination.currentPage,
        //   limit: 4,
        //   search: this.searchTerm,
        //   archived: this.showArchived,
        // });
        await this.getQuotes(this.pagination.currentPage);
      } catch (err) {
        this.errorMessage =
          err.response?.data?.details ||
          "Impossibile archiviare il preventivo.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.archiving = false;
        this.selectedQuote = null;
      }
    },

    openRestoreModal(quote) {
      this.currentQuoteId = quote?.id ?? null;
      this.selectedQuote = quote;
      this.showRestoreModal = true;
    },
    openDiscountModal(quote) {
      if (!this.features.priceModifiers) return;
      this.currentQuoteId = quote?.id ?? null;
      this.selectedQuote = quote;
      this.showDiscountModal = true;
      this.docSearchTerm = ""; // reset ricerca
      this.selectedDocuments = quote.documents || [];
    },
    closeDiscountModal() {
      if (this.restoring) return;
      this.showDiscountModal = false;
      this.selectedQuote = null;
      this.currentQuoteId = null;
      this.selectedDocuments = [];
      this.docSearchTerm = "";
    },
    closeRestoreModal() {
      if (this.restoring) return;
      this.showRestoreModal = false;
      this.selectedQuote = null;
      this.currentQuoteId = null;
    },
    async confirmRestore() {
      if (!this.selectedQuote) return;
      try {
        this.restoring = true;
        let response;
        if (this.$store._actions?.restoreQuote) {
          response = await this.restoreQuote(this.selectedQuote.id);
        } else {
          response = await this.$axios.patch(
            `quote/archive/${this.selectedQuote.id}`,
            { isArchived: false }
          );
        }
        this.successMessage =
          response.data?.message || "Preventivo ripristinato con successo.";
        this.$toast.success(this.successMessage);

        this.showRestoreModal = false;
        this.currentQuoteId = null;

        await this.refreshArchivedFlag();

        if (this.showArchived && !this.hasArchived) {
          this.showArchived = false;
          await this.getQuotes(1); // carica la prima pagina degli attivi
          return; // evita ulteriori fetch sulla vista archiviati
        }
        // await this.fetchQuotes({
        //   page: this.pagination.currentPage,
        //   limit: 4,
        //   search: this.searchTerm,
        //   archived: this.showArchived,
        //   isConfirmed: this.filterConfirmed,
        // });
        await this.getQuotes(this.pagination.currentPage);
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message ||
          err.response?.data?.details ||
          "Impossibile ripristinare il preventivo.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.restoring = false;
        this.selectedQuote = null;
      }
    },

    /* ----- Ricerca/paginazione ----- */
    async onSearch() {
      this.isLoading = true;
      try {
        this.currentPage = 1;
        await this.fetchQuotes({
          page: 1,
          limit: 7,
          search: this.searchTerm,
          archived: this.showArchived,
          isConfirmed: this.filterConfirmed,
          bozze: this.soloBozze,
        });
      } catch (err) {
        if (err?.response?.status !== 404) {
          const msg =
            err?.response?.data?.message ||
            err?.response?.data?.details ||
            "Errore nel caricamento dei preventivi.";
          this.errorMessage = msg;
          this.$toast.error(msg);
        }
      } finally {
        this.isLoading = false;
      }
    },

    async onResetSearch() {
      this.isLoading = true;
      try {
        this.currentPage = 1;
        this.searchTerm = "";
        await this.fetchQuotes({
          page: 1,
          limit: 7,
          archived: this.showArchived,
          bozze: this.soloBozze,
        });
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.details ||
          "Errore durante il reset della ricerca.";
        this.errorMessage = msg;
        this.$toast.error(msg);
      } finally {
        this.isLoading = false;
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.pagination.totalPages) return;
      this.getQuotes(page);
    },

    async getQuotes(page, search = this.searchTerm) {
      this.isLoading = true;
      try {
        const res = await this.fetchQuotes({
          page,
          limit: 7,
          search,
          archived: this.showArchived,
          isConfirmed: this.filterConfirmed,
          bozze: this.soloBozze,
        });
        await this.refreshArchivedFlag();
        return res;
      } catch (error) {
        if (error?.response?.status === 404 && page !== 1) {
          // prova la prima pagina
          try {
            await this.fetchQuotes({
              page: 1,
              limit: 7,
              search,
              archived: this.showArchived,
              isConfirmed: this.filterConfirmed,
              bozze: this.soloBozze,
            });
            this.pagination.currentPage = 1;
            return;
          } catch (_) {
            /* ignora, gestiamo sotto */
          }
        }
        if (error?.response?.status !== 404) {
          this.$nextTick(() => {
            this.errorMessage =
              error?.response?.data?.message ||
              error?.response?.data?.details ||
              "Errore nel caricamento dei preventivi.";
            this.$toast.error(this.errorMessage);
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    async onToggleArchived(e) {
      this.currentPage = 1;
      await this.getQuotes(1);
      await this.refreshArchivedFlag();

      // chiude subito il tooltip 'sticky' perchè rimuove il focus
      if (e && e.target && typeof e.target.blur === "function") {
        e.target.blur();
      }
    },

    async refreshArchivedFlag() {
      this.hasArchived = await this.hasArchivedQuotes();
    },

    async getQuotebyId(quoteId) {
      try {
        const response = await axiosInstance.get(`/quote/${quoteId}`);
        // console.log("quote by id", response);
        if (response.status === 200) return response.data.quote;
        throw new Error("Errore durante il recupero del preventivo.");
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Impossibile caricare i dati del preventivo.";
        this.$toast.error(this.errorMessage);
      }
    },

    /* Articoli del preventivo con la scheda incompleta: senza mq/scatola e
       pz/scatola l'ordine non è evadibile, quindi il preventivo non si conferma */
    incompleteStockItems(quote) {
      return (quote?.items || []).filter((it) => hasIncompleteStockData(it));
    },

    hasIncompleteStockItems(quote) {
      return this.incompleteStockItems(quote).length > 0;
    },

    incompleteStockTitle(quote) {
      const items = this.incompleteStockItems(quote);
      if (!items.length) return "";
      const details = items
        .map(
          (it) =>
            `${itemStockLabel(it)} (manca ${missingStockFields(it).join(", ")})`
        )
        .join(" · ");
      return `Scheda articolo incompleta: ${details}. Completa i dati prima di confermare il preventivo.`;
    },

    onQuoteStateChange(quote, field, newValue) {
      // conferma bloccata finché gli articoli non hanno i dati scatola: senza
      // quelli l'ordine non è evadibile
      if (field === "isConfirmed" && newValue === true) {
        const incomplete = this.incompleteStockItems(quote);
        if (incomplete.length) {
          quote.isConfirmed = false;
          this.pendingChange = null;
          const names = incomplete.map((it) => itemStockLabel(it)).join(", ");
          this.$toast.error(
            `Preventivo non confermabile: completa la scheda articolo (mq/scatola, pz/scatola) di ${names}.`
          );
          return;
        }
      }

      // salva cosa stai cambiando
      this.pendingChange = { id: quote.id, field, newValue };

      const qid = quote?.id ?? "—"; // 👈 ID del preventivo
      const clientName = quote?.Client?.clientName ?? "cliente";

      if (field === "isConfirmed" && newValue === true) {
        this.confirmTitle = "Conferma preventivo";
        this.confirmMessage =
          `Confermare il preventivo <strong>#${qid}</strong> di ` +
          `<strong>${clientName}</strong>?`;
        this.confirmLabel = "Conferma";
        this.confirmBusyLabel = "Confermo…";
      } else if (field === "payment_state" && newValue === "Pagato") {
        const warn =
          quote.state === "Consegnato"
            ? " Confermando <strong>Pagato</strong> non potrai più modificarlo e verrà archiviato dagli attivi."
            : "";
        this.confirmTitle = "Conferma pagamento";
        this.confirmMessage =
          `Impostare il pagamento su <strong>Pagato</strong> per il preventivo ` +
          `<strong>#${qid}</strong> di <strong>${clientName}</strong>?${warn}`;
        this.confirmLabel = "Stato => Pagato";
        this.confirmBusyLabel = "Imposto…";
      } else if (field === "state" && newValue === "In consegna") {
        this.confirmTitle = "Manda in consegna";
        this.confirmMessage =
          `Mandare in consegna il preventivo <strong>#${qid}</strong> di ` +
          `<strong>${clientName}</strong>?<br>` +
          `Questa azione scaricherà lo stock degli articoli.`;
        this.confirmLabel = "Manda in consegna";
        this.confirmBusyLabel = "Aggiorno…";
      } else if (field === "state" && newValue === "Consegnato") {
        const warn =
          quote.payment_state === "Pagato"
            ? " Confermando <strong>Consegnato</strong> non potrai più modificarlo e verrà archiviato dagli attivi."
            : "";
        this.confirmTitle = "Conferma consegna";
        this.confirmMessage =
          `Segnare come <strong>Consegnato</strong> il preventivo ` +
          `<strong>#${qid}</strong> di <strong>${clientName}</strong>?${warn}`;
        this.confirmLabel = "Stato => Consegnato";
        this.confirmBusyLabel = "Aggiorno…";
      } else {
        this.confirmTitle = "Conferma modifica";
        this.confirmMessage =
          `Confermare la modifica dello stato per il preventivo ` +
          `<strong>#${qid}</strong> di <strong>${clientName}</strong>?`;
        this.confirmLabel = "Conferma";
        this.confirmBusyLabel = "Aggiorno…";
      }

      this.showConfirmModal = true;
    },

    handleConfirmCancel() {
      // Ripristina i dati UI ricaricando la pagina corrente (più semplice e sicuro)
      this.showConfirmModal = false;
      this.pendingChange = null;
      this.getQuotes(this.pagination.currentPage);
    },

    async handleConfirmOK() {
      if (!this.pendingChange) return;
      const { id, newValue } = this.pendingChange;

      this.confirmBusy = true;
      try {
        await this.updateQuoteState(id, newValue);
      } finally {
        this.confirmBusy = false;
        this.showConfirmModal = false;
        this.pendingChange = null;
      }
    },

    async updateQuoteState(quoteId, newState) {
      this.successMessage = "";
      this.errorMessage = "";
      // const quote = await this.getQuotebyId(quoteId);

      try {
        // if (quote.payment_state === "Pagato" && newState === "Consegnato") {
        //   const ok = window.confirm(
        //     "Il preventivo è già stato pagato. Confermando 'Consegnato' non potrai più modificarlo e sparirà dagli attivi. Procedere?"
        //   );
        //   if (!ok) return this.getQuotes();
        // }
        // if (quote.state === "Consegnato" && newState === "Pagato") {
        //   const ok = window.confirm(
        //     "Il preventivo è già stato consegnato. Confermando 'Pagato' non potrai più modificarlo e sparirà dagli attivi. Procedere?"
        //   );
        //   if (!ok) return this.getQuotes();
        // }

        // const ok = window.confirm(
        //   "Sei sicuro di voler confermare questo preventivo?"
        // );
        // if (!ok) return this.getQuotes();

        // L'oggetto va passato così com'è: axios scrive `application/json` da
        // sé solo quando il corpo è un oggetto. Con una stringa già pronta non
        // manda nessun tipo, il server non analizza il corpo e risponde che lo
        // stato manca. [sc-48350]
        const response = await this.$axios.patch(`quote/state/${quoteId}`, {
          state: newState,
        });

        if (response.status === 200 || response.status === 201) {
          if (newState === true) {
            this.successMessage =
              response.data.message ||
              "Il preventivo è stato confermato con successo.";
            this.$toast.success(this.successMessage);
          } else if (newState === "Consegnato") {
            this.successMessage =
              response.data.message || "Stato aggiornato a 'Consegnato'.";
            this.$toast.success(this.successMessage);
          } else if (newState === "Pagato") {
            this.successMessage =
              response.data.message || "Stato aggiornato a 'Pagato'.";
            this.$toast.success(this.successMessage);
          } else if (newState === "In consegna") {
            this.successMessage =
              response.data?.message || "Stato aggiornato a 'In consegna'.";
            this.$toast.success(this.successMessage);
          }

          const q = this.allQuotes.find((q) => q.id === quoteId);
          if (q) {
            if (newState === "Pagato") {
              q.payment_state = newState;
            } else if (
              newState === "Consegnato" ||
              newState === "In consegna"
            ) {
              q.state = newState;
            } else {
              q.isConfirmed = newState;
            }
            if (response.data?.quote?.Client?.lastQuote !== undefined) {
              q.lastQuote = response.data.quote.Client.lastQuote;
            }
          }

          if (q?.payment_state === "Pagato" && q?.state === "Consegnato") {
            setTimeout(async () => {
              // await this.fetchQuotes({
              //   page: this.pagination.currentPage,
              //   limit: 4,
              //   search: this.searchTerm,
              // });
              await this.refreshArchivedFlag();
              await this.getQuotes(this.pagination.currentPage);
              this.successMessage =
                "Stato aggiornato e preventivo archiviato con successo.";
              this.$toast.success(this.successMessage);
            }, 1000);
          }
        }
      } catch (error) {
        const status = error.response?.status;
        const data = error.response?.data ?? {};

        if (status === 409 && data.code === "STOCK_INSUFFICIENT") {
          this.errorMessage =
            data.message || "Stock insufficiente per uno o più articoli.";
        } else if (status === 409) {
          this.errorMessage =
            data.details ||
            data.message ||
            `Lo stato del preventivo con ID '${quoteId}' è già '${newState}'`;
        } else {
          this.errorMessage =
            data.details || data.error || "Errore durante l'aggiornamento.";
        }

        this.$toast.error(this.errorMessage);
        this.getQuotes();
      }
    },

    /* ---- utilità stato preventivo ---- */
    isCompleted(quote) {
      // consideriamo "completato" quando è Pagato + Consegnato
      return quote?.payment_state === "Pagato" && quote?.state === "Consegnato";
    },

    canRestore(quote) {
      // negli archiviati non mostriamo il ripristino se è già completato
      return !this.isCompleted(quote);
    },

    canEdit(quote) {
      // se sto guardando gli archiviati e il preventivo è completato => niente modifica
      return !(
        this.showArchived &&
        (this.canRestore(quote) || this.isCompleted(quote))
      );
    },
  },

  watch: {
    $route(to, from) {
      const toName = to?.name;
      const fromName = from?.name; // può essere undefined al primo giro
      if (toName === "quotes" && fromName !== "quotes") {
        this.getQuotes(this.currentPage);
      }
    },
    searchTerm() {
      this.onSearch();
    },
    // "$route.name"(toName) {
    //   if (toName === "quotes") this.getQuotes(this.currentPage);
    // },
  },

  async mounted() {
    await this.refreshArchivedFlag();
    this.getQuotes(this.currentPage);

    document.addEventListener("click", this.handleDocumentClick, {
      passive: true,
    });
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
};
</script>

<style src="@/css/QuotePage.css"></style>
